import{Breadcrumbs}from'common/components/Breadcrumbs/Breadcrumbs';export default Breadcrumbs;